export enum RouteKey {
  Details = 'details',
  Entities = 'entities',
  Files = 'files',
}

export type SceneMap = {
  [key in RouteKey]: TabScene;
};

export type RouteParams = {
  projectId: string;
  tab?: RouteKey;
};

export type TabScene = {
  component: React.ComponentType;
  path: string;
  title: string | React.ReactNode;
};